export default function formatClasses(
  classes: Array<string | undefined | null>,
) {
  return classes.filter(Boolean).join(' ')
}
